/**
 * Dietitian App - Merkezi Renk Paleti
 * Tüm renklerin tek bir yerden yönetildiği tema dosyası
 */

export const colors = {
  // Ana Yeşil Tonları
  primary: {
    main: '#43A047', // Ana yeşil
    dark: '#2E7D32', // Koyu yeşil
    medium: '#388E3C', // Orta yeşil
    light: '#A5D6A7', // Açık yeşil
    lighter: '#C8E6C9', // Daha açık yeşil
  },

  // Arka Plan Renkleri
  background: {
    main: '#f5f7fa', // Ana arka plan
    paper: '#FFFFFF', // Kart arka planı
    light: '#F9FAF7', // Açık yeşilimsi arka plan
    overlay: 'rgba(255, 255, 255, 0.98)', // Modal/overlay arka plan
  },

  // Metin Renkleri
  text: {
    primary: '#263238', // Ana metin rengi
    secondary: '#607D8B', // İkincil metin
    disabled: '#9E9E9E', // Devre dışı metin
    hint: '#B0BEC5', // Yardımcı metin
  },

  // Border & Divider
  border: {
    light: '#e0e0e0', // Açık border
    main: '#e2e8f0', // Ana border
    dark: '#BDBDBD', // Koyu border
  },

  // Durum Renkleri
  status: {
    success: '#2E7D32', // Başarılı
    warning: {
      main: '#FF9800', // Ana turuncu (warning)
      dark: '#F57C00', // Koyu turuncu
      light: '#FFA726', // Açık turuncu
      background: 'rgba(255, 152, 0, 0.1)', // Açık turuncu arka plan
      border: 'rgba(255, 152, 0, 0.2)', // Turuncu border
      hover: 'rgba(255, 152, 0, 0.08)', // Hover arka plan
    },
    error: '#E53935', // Hata
    info: '#42A5F5', // Bilgi
  },

  // Gradyanlar
  gradients: {
    primary: 'linear-gradient(135deg, #43A047 0%, #2E7D32 100%)',
    primaryLight: 'linear-gradient(135deg, #43A047 0%, #A5D6A7 100%)',
    primaryMedium: 'linear-gradient(135deg, #2E7D32 0%, #43A047 100%)',
    backgroundOverlay:
      'linear-gradient(135deg, rgba(46, 125, 50, 0.85) 0%, rgba(67, 160, 71, 0.75) 100%)',
  },

  // Gölgeler
  shadows: {
    card: '0 2px 4px rgba(0, 0, 0, 0.1)',
    cardHover: '0 12px 24px rgba(67, 160, 71, 0.2)',
    button: '0 4px 12px rgba(67, 160, 71, 0.25)',
    icon: '0 8px 24px rgba(67, 160, 71, 0.3)',
    elevated: '0 20px 60px rgba(0, 0, 0, 0.25)',
  },

  // Özel Renkler (Chip, Badge vb. için)
  chip: {
    primaryBg: 'linear-gradient(135deg, #43A04715 0%, #2E7D3215 100%)',
    primaryBorder: '#43A04730',
    secondaryBg: 'linear-gradient(135deg, #A5D6A715 0%, #43A04715 100%)',
    secondaryBorder: '#A5D6A730',
  },

  // Hover & Active Durumları (yumuşak tonlar)
  hover: {
    primary: '#388E3C',       // primary.medium – hafif koyulaşma
    background: '#F1F8E9',    // Çok hafif yeşil (Light Green 50 soft)
    border: '#66BB6A',       // Hafif yeşil – outlined hover vurgusu
  },

  // Özel Alfa Değerleri
  alpha: {
    primary05: 'rgba(67, 160, 71, 0.05)',
    primary10: 'rgba(67, 160, 71, 0.1)',
    primary15: 'rgba(67, 160, 71, 0.15)',
    primary20: 'rgba(67, 160, 71, 0.2)',
    primary25: 'rgba(67, 160, 71, 0.25)',
    primary30: 'rgba(67, 160, 71, 0.3)',
    white05: 'rgba(255, 255, 255, 0.05)',
    white10: 'rgba(255, 255, 255, 0.1)',
    white30: 'rgba(255, 255, 255, 0.3)',
    white50: 'rgba(255, 255, 255, 0.5)',
    white98: 'rgba(255, 255, 255, 0.98)',
  },
} as const;

export type Colors = typeof colors;

export default colors;
